import { path } from 'ramda';

import { usePortletConfig } from 'js/components/system/Portlet';

export const useCustomCategory = categoryName => {
    const customCategories = path(['customCategories', 'category'], usePortletConfig());

    return categoryName
        ? customCategories?.find(custom => custom.categoryName === categoryName) || {}
        : {};
};
